import React from 'react'
import { Form } from 'react-bootstrap';
import { useForm } from 'react-hook-form'
import CustomButton from '../../shared/CustomButton';

const ResetPasswordForm = ({
    isSaving,
    formAction,
    onBack
}) => {
    const {
        register,
        handleSubmit,
        reset,
        setError,
        getValues,
        formState: {errors}
    } = useForm();

    const resetForm = () => {
        reset({
            'password': '',
            'password_confirmation': ''
        });
    }

    const onSubmit = async (data) => {
        try {
            const success = await formAction(data);
            if (success){
                resetForm();
            }
        } catch (error) {
            resetForm(); // clear all form fields 
            console.log(error.response.status);
            if (error.response && error.response.status === 422){
                Object.keys(error.response.data.errors).forEach((field) => {
                    setError(field, {
                        type: 'manual',
                        message: error.response.data.errors[field][0]
                    });
                });
            } else {
                throw error; // error to be handled in PasswordReset.jsx by resetPassword()
            }
        }
    }
  return (
    <Form onSubmit={handleSubmit(onSubmit)}>

        <Form.Group>

            <Form.Label htmlFor='password'>New Password</Form.Label>
            <input type='password' autoFocus placeholder='New Password'
                className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                {...register('password', {
                    required: 'Enter your new password'
                })}
            />
            {errors.password && (
                <div className="invalid-feedback">{errors.password.message}</div>
            )}

        </Form.Group>

        <Form.Group>

            <Form.Label htmlFor='password_confirmation'>Confirm New Password</Form.Label>
            <input type='password' placeholder='Confirm New Password'
                className={`form-control ${errors.password_confirmation ? 'is-invalid' : ''}`}
                {...register('password_confirmation', {
                    required: 'Confirm your new password',
                    validate: (value) => value === getValues('password') || 'Passwords do not match'
                })}
            />
            {errors.password_confirmation && (
                <div className="invalid-feedback">{errors.password_confirmation.message}</div>
            )}

        </Form.Group>

        <CustomButton
            title={isSaving ? 'Resetting Password' : 'Reset Password'}
            isSaving={isSaving}
        />

        <div className="text-center">
            <a href='#' className='auth-link' onClick={(e) => {e.preventDefault(); onBack()}}>Back to Login?</a>
        </div>

    </Form>
  )
}

export default ResetPasswordForm